// Situacao do emprego, e o mercado de treinadores quando voce esta sem clube.

import React from 'react';
import { jobStatus, takeJob, refreshJobOffers, teamById } from '../engine/career.js';
import { reputationLabel } from '../engine/jobs.js';
import { Crest } from './crest.jsx';

/** Faixa de pressao mostrada no painel, junto do proximo jogo. */
export function JobBar({ state }) {
  if (state.unemployed) return null;
  const s = jobStatus(state);
  const pct = s.record && s.record.games ? s.record.wins / s.record.games : null;

  return (
    <div className="card tight meta-board">
      {/* Rótulo e situação na mesma linha, com a situação encostada à direita;
          a barra abaixo; e o rodapé com os dois números que a explicam. Antes
          eram quatro textos disputando espaço em duas linhas tortas. */}
      <div className="linha">
        <span className="small dim">
          Meta: <b className="acc">{s.targetText}</b>
          {' · '}{Math.round(s.target * 100)}% de vitorias
        </span>
        <span className={`small ${s.cls}`} style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
          {s.text}
        </span>
      </div>

      <div className="mood">
        <div className="mood-track">
          <div className="mood-target" style={{ left: `${s.target * 100}%` }} />
          {pct !== null && (
            <div
              className={`mood-fill ${pct >= s.target ? 'ok' : 'ruim'}`}
              style={{ width: `${Math.min(100, pct * 100)}%` }}
            />
          )}
        </div>
      </div>

      <div className="rodape">
        <span>{pct !== null ? `voce: ${Math.round(pct * 100)}%` : 'temporada nao comecou'}</span>
        <span style={{ textAlign: 'right' }}>
          reputacao {s.reputation} · {s.reputationText}
        </span>
      </div>
    </div>
  );
}

/** Tela de quem foi demitido: a liga segue, e as vagas aparecem na entressafra. */
export function Unemployed({ state, apply, busy, onAdvance }) {
  const antigo = state.formerClubId ? teamById(state, state.formerClubId) : null;
  const vagas = state.jobOffers || [];
  const emTemporada = state.phase === 'regular' || state.phase === 'playoffs';

  return (
    <>
      <div className="pitch">
        <span className="tag">sem clube</span>
        <div style={{ fontSize: 19, fontWeight: 800, marginTop: 6, letterSpacing: '-.02em' }}>
          Voce esta sem clube
        </div>
        <div className="muted small" style={{ marginTop: 4 }}>
          {antigo ? `O ${antigo.name} dispensou voce. ` : ''}
          {emTemporada
            ? 'A temporada segue sem voce. Tecnico demitido no meio do ano quase nunca assume outro time na mesma temporada -- as vagas abrem na entressafra.'
            : 'Escolha um clube abaixo para recomecar.'}
        </div>
        <div className="row spread small" style={{ marginTop: 10 }}>
          <span className="dim">Sua reputacao</span>
          <b className="acc">{state.reputation} · {reputationLabel(state.reputation)}</b>
        </div>
      </div>

      {emTemporada && (
        <div className="card">
          <div className="small muted" style={{ marginBottom: 10 }}>
            Avance ate o fim da temporada para ver quem procura tecnico.
          </div>
          <div className="row wrap" style={{ gap: 8 }}>
            <button className="primary" disabled={busy} onClick={() => onAdvance(5)}>+5 rodadas</button>
            <button className="ghost" disabled={busy} onClick={() => onAdvance(20)}>+20 rodadas</button>
          </div>
        </div>
      )}

      {!emTemporada && (
        <>
          <div className="row spread" style={{ marginBottom: 8 }}>
            <h2 style={{ margin: 0 }}>Clubes que procuram tecnico</h2>
            <button
              className="ghost sm"
              onClick={() => apply((s) => { refreshJobOffers(s); return { state: s, events: [] }; })}
            >
              atualizar
            </button>
          </div>
          {!vagas.length ? (
            <div className="card dim small">
              Nenhum clube procurando agora. Avance ate a proxima entressafra --
              e assim que funciona: quem e demitido espera a vaga aparecer.
            </div>
          ) : vagas.map((vaga) => {
            const team = teamById(state, vaga.teamId);
            return (
              <div key={vaga.teamId} className="card">
                <div className="row spread" style={{ marginBottom: 8 }}>
                  <div className="row" style={{ gap: 10, minWidth: 0 }}>
                    <Crest team={team} size={34} />
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 700 }}>{vaga.teamName}</div>
                      <div className="small dim">
                        Espera: {vaga.targetText} · {Math.round(vaga.target * 100)}% de vitorias
                      </div>
                    </div>
                  </div>
                  <span className={`pill ${vaga.interesse >= 75 ? 'on' : ''}`}>
                    {vaga.interesse >= 75 ? 'querem voce' : vaga.interesse >= 60 ? 'interessados' : 'ouviriam'}
                  </span>
                </div>
                <button className="primary" style={{ width: '100%' }}
                  onClick={() => apply((s) => takeJob(s, vaga.teamId))}>
                  Assumir o {vaga.teamName}
                </button>
              </div>
            );
          })}
        </>
      )}
    </>
  );
}
